module.exports = __webpack_public_path__ + "img/login.e62e591c.png";